<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-23 09:57 -->
<!-- Description:  -->
<template>
  <div>
    <div class="list-group mb-4">
      <div class="list-group-item list-group-item-action" v-for="item in list" :key="item.id">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{item.name}}<span v-if="item.code"> - [{{item.code}}]</span></h5>
        </div>
        <div>
          <small>{{ item.employee_name }}</small>
        </div>
        <div class="mb-1 d-flex">
          <span class="mr-auto">{{ item.specialty_name }}</span>
          <app-span-money :moneyCode="1" :quantity="item.sum_budget"></app-span-money>
        </div>

        <router-link class="btn btn-primary btn-sm" :to="{ name: 'dental.patient.treatment', params: {
          client_id: item.client_id,
          id: item.id,
          }}">
          Ver Detalles
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
import DentalClinicService from '../service';

// script content
export default {
  name: "TreatmentCardList",
  components: {
    //
  },

  // directives

  props: {
    client_id: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    list: []
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.reload();
  },

  methods: {
    async reload() {
      let res = await DentalClinicService.getTreatmentPlans({
        client_id: this.client_id,
      });
      this.list = res.data;
    }
    //
    //
  }
};
</script>
<style scoped></style>

